/**
 * `useChapters` returns pages newest-first, and each page is newest-first inside itself
 * (`ChapterPage.chapters`: "Newest first"). A feed is read oldest-first. That double reversal
 * is the kind of thing that looks correct on a one-page story and is wrong the moment the
 * `before` cursor pages, so it is one tested function rather than an inline `.reverse()`.
 */
import type { Chapter } from '@/api/generated';

/** Oldest first — the order a feed is read in, and what `deriveDatelines` requires. */
export function toReadingOrder(pages: readonly { chapters: Chapter[] }[]): Chapter[] {
  return pages.flatMap((page) => page.chapters).sort((a, b) => a.number - b.number);
}
